//#region src/send_description_to_pos.ts
var SendDescriptionToPos = /* @__PURE__ */ function(SendDescriptionToPos) {
	SendDescriptionToPos[SendDescriptionToPos["Never"] = 0] = "Never";
	SendDescriptionToPos[SendDescriptionToPos["Always"] = 1] = "Always";
	SendDescriptionToPos[SendDescriptionToPos["BarcodeScan"] = 2] = "BarcodeScan";
	return SendDescriptionToPos;
}(SendDescriptionToPos || {});
//#endregion
export { SendDescriptionToPos };

//# sourceMappingURL=send_description_to_pos.js.map